import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useHistory } from "react-router-dom";
import { useWizard } from "react-use-wizard";
import OrangeCalendar from "../../img/icons/icon_calendar_orange.png";
import moment from "moment";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import createPersistedState from "use-persisted-state";
import { Button, Modal } from "react-bootstrap";
import { getTranslatedClinicNameFromId } from "../../utils";
const useClinicState = createPersistedState("clinic");

function ErrorModal({
  isErrorModalOpen,
  setIsErrorModalOpen,
  errorMessage,
  setErrorMessage,
}) {
  return (
    <Modal
      show={isErrorModalOpen}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        setIsErrorModalOpen(false);
        setErrorMessage();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center pb-1">{errorMessage && errorMessage}</p>
      </Modal.Body>
    </Modal>
  );
}

function ConfirmAppointmentStep({
  currentSlot,
  id,
  isReschedule,
  selectedClinic,
  recDoctor,
}) {
  let history = useHistory();
  const { previousStep } = useWizard();
  const { t } = useTranslation();
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [clinicId, setClinic] = useClinicState();

  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  // to fet date format
  const selectedDate = localStorage.getItem("Date");
  const showTime = moment(currentSlot.id).format("hh:mm A");

  // fetch URL slot booking

  const confirmAppointment = async () => {
    setIsFetchingData(true);
    const token = "Bearer " + localStorage.getItem("token");
    const attendeeId = JSON.parse(localStorage.getItem("pid"));
    const POST_URL = `/api/v1/appointments/${
      selectedClinic === "CC000000" ? currentSlot.clinicId : selectedClinic
    }`;
    try {
      const data = {
        slotId: currentSlot.id,
        attendeeId: attendeeId,
        ownerId: recDoctor.drId,
        online:
          selectedClinic === "CC000000" || selectedClinic === "CC000007"
            ? true
            : false,
      };
      const response = await fetch(`${POST_URL}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();

      if (res.status.code !== 200) {
        console.log(response);

        const error = new Error(res.status.message);

        throw error;
      } else {
        history.push("/my-appointments");
      }
    } catch (err) {
      setErrorMessage(err.message);
      setIsErrorModalOpen(true);
    }
    setIsFetchingData(false);
  };

  // fetch reschedule data
  const rescheduleSlot = async () => {
    setIsFetchingData(true);

    const token = "Bearer " + localStorage.getItem("token");
    const rescheduleURL = `/api/v1/appointments/${id}/reschedule?slotId=${
      currentSlot.id
    }&spaceId=${
      selectedClinic === "CC000000" ? currentSlot.clinicId : selectedClinic
    }`;
    try {
      const body_data = {
        online:
          selectedClinic === "CC000000" || selectedClinic === "CC000007"
            ? true
            : false,
      };
      const response = await fetch(rescheduleURL, {
        method: "PUT",
        body: JSON.stringify(body_data),
        headers: {
          Accept: "application/json; charset=utf-8",
          "Content-Type": "application/json",
          Authorization: token.replace(/['"]+/g, ""),
        },
        credentials: "include",
      });
      const res = await response.json();
      // console.log(data);

      if (res.status.code !== 200) {
        const error = new Error(res.status.message);

        throw error;
        return;
      } else {
        history.push("/my-appointments");
      }
    } catch (err) {
      setErrorMessage(err.message);
      setIsErrorModalOpen(true);
    }
    setIsFetchingData(false);
  };

  const handleClick = () => {
    if (isReschedule) {
      rescheduleSlot();
    } else {
      confirmAppointment();
    }
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={() => previousStep()}
        title={t("appointment.CONFIRMED.message2")}
      />
      <div className="body_content py-3">
        <div className="inner_body  text-center">
          <div>
            <span className="icon">
              <img
                src={OrangeCalendar}
                alt=""
                className="img-fluid d-block mx-auto w-25 mt-3"
              />
            </span>
          </div>
          <div className="modal-body">
            <div className="content_modal">
              <h4 className="w-100 mt-4 mb-4 headtitle fw-bold text-center">
                {t("appointment.CONFIRMED.message3")} <br />{" "}
                {t("appointment.CONFIRMED.message4")}
              </h4>
              <div className="text-center w-100">
                <p className="txt_small mb-3">
                  {/* {t("appointment.CONFIRMED.doctor-name")} */}
                  {recDoctor.drName}
                </p>
                <p className="txt_small mb-3">{showTime}</p>
                <p className="txt_small mb-3">
                  {moment(new Date(selectedDate)).format("Do MMMM YYYY, dddd")}
                </p>
                <p className="txt_small mb-3">
                  {getTranslatedClinicNameFromId(selectedClinic, t)}
                </p>
              </div>
            </div>
          </div>
          <div className="btn_block bottom_button d-flex justify-content-center p-3">
            <button
              className="w-50 btn btn_outline"
              onClick={() => history.push("/my-appointments")}
            >
              {t("appointment.BUTTON.cancel")}
            </button>
            <button
              className="w-50  btn btn_primary"
              disabled={isFetchingData}
              onClick={handleClick}
            >
              {isFetchingData && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              &nbsp;{t("appointment.BUTTON.confirm")}
            </button>
          </div>
        </div>
        <ErrorModal
          isErrorModalOpen={isErrorModalOpen}
          setIsErrorModalOpen={setIsErrorModalOpen}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />
      </div>
    </>
  );
}

export default ConfirmAppointmentStep;
